module.exports = __webpack_public_path__ + "img/station.6a03e89c.png";